import URI from 'urijs'
import _ from 'underscore'
import { bindings } from '../'
import { appConfig } from './config_app_util.js'

const configApp = async (config) => {
  // Do nothing if config is empty
  if (_.isEmpty(config)) {
    return
  }

  const currentUri = new URI(window.location.href)

  // NOTE: Need to figure out if the native app knows we're already logged in,
  // otherwise, this will make the native app refresh the background window and
  // we'll be in an infinite loop.
  if (!/background/i.test(currentUri.pathname())) {
    await bindings.configApp(config)
  }
}

/**
 * Notify the platform that a user has logged into the web app.
 *
 * The platform can do whatever it deems appropriate with this knowledge.
 * Usually this information is used to enable UI elements that are only applicable
 * with a logged in user.
 *
 * @param {Backbone.Model} model - user model
 */
export const login = async (user) => {
  await bindings.login(user.get('login'))
  await configApp({ ...appConfig(), ...user.get('features') })
}

/**
 * Notify the platform that a user has logged out of the web app.
 *
 * The platform can do whatever it deems appropriate with this knowledge.
 * Usually this information is used to disable controls that don't make sense
 * without a logged in user.
 *
 * @param {Backbone.Model} model - user model
 */
export const logout = async () => {
  await bindings.logout()
}
